import { useEffect, useState, useRef } from "react";
import "@/App.css";
import { motion, useInView, useScroll, useTransform } from "framer-motion";
import Marquee from "react-fast-marquee";
import { 
  Trees, 
  Mountain, 
  Wifi, 
  ChefHat, 
  MapPin, 
  Mail, 
  Phone, 
  Home,
  Droplets,
  Leaf,
  WashingMachine,
  UtensilsCrossed,
  Bed,
  Armchair,
  ChevronDown,
  Star,
  Quote,
  Clock,
  Camera,
  Navigation,
  Waves,
  Sunrise,
  Car,
  Plane,
  Train,
  ShieldCheck,
  Ban,
  CreditCard,
  Video,
  AlertTriangle,
  CheckCircle2
} from "lucide-react";

// Assets
const LOGO = "https://customer-assets.emergentagent.com/job_pepper-valley-stay/artifacts/uge46uyu_image_4f7001e1-aa4c-43b4-990c-d1c61d9b0b41.png";
const HERO_BG = "https://customer-assets.emergentagent.com/job_pepper-valley-stay/artifacts/rjdv06xu_20260112_165809.jpg";
const ABOUT_IMG = "https://customer-assets.emergentagent.com/job_pepper-valley-stay/artifacts/h9mj3tel_20260112_165756.jpg";

// Farm Gallery Images
const FARM_GALLERY = [
  "https://customer-assets.emergentagent.com/job_pepper-valley-stay/artifacts/h9mj3tel_20260112_165756.jpg",
  "https://customer-assets.emergentagent.com/job_pepper-valley-stay/artifacts/jv48jrt0_20260112_165754.jpg",
  "https://images.unsplash.com/photo-1667135660783-d4d3107402e6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHw0fHxtaXN0eSUyMHRyb3BpY2FsJTIwdmFsbGV5JTIwaGlsbHMlMjBzdW5yaXNlfGVufDB8fHx8MTc3MjI3NjQ4Mnww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1667852670811-0fa4cad65b57?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxibGFjayUyMHBlcHBlciUyMHZpbmUlMjBwbGFudCUyMGNsb3NldXAlMjBuYXR1cmV8ZW58MHx8fHwxNzcyMjc2NDgxfDA&ixlib=rb-4.1.0&q=85"
];

// House Interior Images (User's actual house photos)
const HOUSE_GALLERY = [
  "https://customer-assets.emergentagent.com/job_pepper-valley-stay/artifacts/rxc3ajuq_IMG-20260218-WA0066%281%29.jpg",
  "https://customer-assets.emergentagent.com/job_pepper-valley-stay/artifacts/imtlc3zp_IMG-20260218-WA0073%281%29.jpg",
  "https://customer-assets.emergentagent.com/job_pepper-valley-stay/artifacts/krfntoa6_IMG-20260218-WA0091.jpg",
  "https://customer-assets.emergentagent.com/job_pepper-valley-stay/artifacts/ktwen2qk_IMG-20260218-WA0064%281%29.jpg"
];

// Viewpoint Images
const VIEWPOINT_GALLERY = [
  "https://images.unsplash.com/photo-1629813538702-64c925934e19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxLZXJhbGElMjBoaWxsJTIwdmFsbGV5JTIwdmlld3BvaW50JTIwc3VucmlzZXxlbnwwfHx8fDE3NzIyOTgxOTN8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1628771506082-b5990e01c106?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxLZXJhbGElMjBoaWxsJTIwdmFsbGV5JTIwdmlld3BvaW50JTIwc3VucmlzZXxlbnwwfHx8fDE3NzIyOTgxOTN8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1632145862685-b79a785aceb4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxLZXJhbGElMjBoaWxsJTIwdmFsbGV5JTIwdmlld3BvaW50JTIwc3VucmlzZXxlbnwwfHx8fDE3NzIyOTgxOTN8MA&ixlib=rb-4.1.0&q=85"
];

// Nearby Attractions Data
const NEARBY_ATTRACTIONS = [
  {
    name: "Siruvani Dam",
    distance: "15 km",
    description: "Famous for having the second sweetest water in the world. Beautiful reservoir surrounded by lush forests.",
    image: "https://images.unsplash.com/photo-1700360898675-d87fdc8a71aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxTaXJ1dmFuaSUyMGRhbSUyMEtlcmFsYSUyMHNjZW5pY3xlbnwwfHx8fDE3NzIyOTgxOTF8MA&ixlib=rb-4.1.0&q=85",
    icon: Waves
  },
  {
    name: "Meenvallam Waterfalls",
    distance: "12 km",
    description: "A spectacular 7-tiered waterfall amidst dense forest. Perfect for trekking and nature photography.",
    image: "https://images.unsplash.com/photo-1741845100134-9903bf7fbb62?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxLZXJhbGElMjB3YXRlcmZhbGwlMjBmb3Jlc3QlMjBncmVlbnxlbnwwfHx8fDE3NzIyOTgxOTF8MA&ixlib=rb-4.1.0&q=85",
    icon: Droplets
  },
  {
    name: "Kanjirapuzha Dam",
    distance: "20 km",
    description: "Scenic earthen dam with gardens and boating. Popular picnic spot with panoramic views.",
    image: "https://images.unsplash.com/photo-1659443374861-10be174bc85c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxLZXJhbGElMjB3YXRlcmZhbGwlMjBmb3Jlc3QlMjBncmVlbnxlbnwwfHx8fDE3NzIyOTgxOTF8MA&ixlib=rb-4.1.0&q=85",
    icon: Mountain
  },
  {
    name: "Palakkad Fort",
    distance: "35 km",
    description: "Historic 18th-century fort built by Hyder Ali. A well-preserved example of military architecture.",
    image: "https://images.unsplash.com/photo-1719400525704-dca5a44747c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxTaXJ1dmFuaSUyMGRhbSUyMEtlcmFsYSUyMHNjZW5pY3xlbnwwfHx8fDE3NzIyOTgxOTF8MA&ixlib=rb-4.1.0&q=85",
    icon: Home
  },
  {
    name: "Silent Valley National Park",
    distance: "45 km",
    description: "One of the last undisturbed tracts of tropical evergreen forest. Home to rare wildlife and birds.",
    image: "https://images.unsplash.com/photo-1628771506082-b5990e01c106?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxLZXJhbGElMjBoaWxsJTIwdmFsbGV5JTIwdmlld3BvaW50JTIwc3VucmlzZXxlbnwwfHx8fDE3NzIyOTgxOTN8MA&ixlib=rb-4.1.0&q=85",
    icon: Trees
  },
  {
    name: "Dhoni Waterfalls",
    distance: "25 km",
    description: "Hidden gem requiring a short trek through forest. Crystal clear water pools perfect for a dip.",
    image: "https://images.unsplash.com/photo-1632145862685-b79a785aceb4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxLZXJhbGElMjBoaWxsJTIwdmFsbGV5JTIwdmlld3BvaW50JTIwc3VucmlzZXxlbnwwfHx8fDE3NzIyOTgxOTN8MA&ixlib=rb-4.1.0&q=85",
    icon: Droplets
  }
];

// Testimonials Data
const TESTIMONIALS = [
  {
    name: "Priya Menon",
    location: "Bangalore",
    rating: 5,
    text: "An absolute paradise! Waking up to bird songs and the sound of the brook was magical. The pepper vines and mango trees made us feel connected to nature. Will definitely return.",
    date: "November 2025"
  },
  {
    name: "Rahul & Family",
    location: "Chennai",
    rating: 5,
    text: "Perfect getaway for our family. The kids loved exploring the farm and learning about areca nuts and rubber trees. The fully equipped kitchen allowed us to cook our own meals!",
    date: "October 2025"
  },
  {
    name: "Sneha Krishnan",
    location: "Kochi",
    rating: 5,
    text: "The valley views at sunrise are breathtaking. Such a peaceful retreat from city life. The fully equipped kitchen and cozy bedrooms made it feel like home.",
    date: "September 2025"
  },
  {
    name: "Arun & Divya",
    location: "Coimbatore",
    rating: 5,
    text: "We visited Siruvani Dam and Meenvallam falls during our stay. The location is perfect for exploring Palakkad's hidden gems. Brookpepper exceeded all our expectations!",
    date: "August 2025"
  }
];

// House Rules Data
const HOUSE_RULES = [
  { icon: ShieldCheck, title: "ID Verification Required", desc: "Valid Aadhaar/Government ID mandatory for all guests at check-in" },
  { icon: Ban, title: "No Illegal Activities", desc: "Strictly prohibited. Any illegal activity will be reported to authorities" },
  { icon: AlertTriangle, title: "No Drugs or Smoking", desc: "This is a smoke-free and drug-free property" },
  { icon: Video, title: "CCTV Surveillance", desc: "Common areas monitored for safety. Your security is our priority" },
  { icon: UtensilsCrossed, title: "Self-Catering Only", desc: "No food service provided. Fully equipped kitchen available for guests to cook" },
  { icon: CheckCircle2, title: "Respect the Property", desc: "Please maintain cleanliness and treat the property with care" }
];

// How to Reach Data
const HOW_TO_REACH = [
  {
    city: "From Palakkad",
    distance: "30 km",
    duration: "45 mins",
    icon: Car,
    directions: "Head towards Siruvani Road from Palakkad town. Continue past Walayar and follow signs to Palakayam. Brookpepper is located 5 km before Siruvani Dam checkpoint."
  },
  {
    city: "From Coimbatore",
    distance: "55 km",
    duration: "1.5 hours",
    icon: Car,
    directions: "Take NH544 towards Palakkad. Cross the Walayar checkpost into Kerala. Turn right towards Siruvani Road and follow to Palakayam area."
  },
  {
    city: "From Cochin/Kochi",
    distance: "150 km",
    duration: "3.5 hours",
    icon: Car,
    directions: "Take NH544 via Thrissur to Palakkad. From Palakkad, head towards Siruvani Road. Alternatively, take a train to Palakkad Junction and hire a cab."
  }
];

// Animation variants
const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.15 } }
};

// Section component with scroll animation
const AnimatedSection = ({ children, className = "", id = "" }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  
  return (
    <motion.section
      ref={ref}
      id={id}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      variants={fadeInUp}
      className={className}
    >
      {children}
    </motion.section>
  );
};

// Navigation Component
const NavigationBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMobileMenuOpen(false);
  };

  const navItems = [
    { id: "about", label: "About" },
    { id: "stay", label: "The Stay" },
    { id: "gallery", label: "Gallery" },
    { id: "attractions", label: "Explore" },
    { id: "testimonials", label: "Reviews" },
    { id: "rules", label: "Rules" },
    { id: "reach", label: "Directions" },
    { id: "contact", label: "Contact" }
  ];

  return (
    <nav 
      data-testid="main-navigation"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "nav-glass py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
        <div className="cursor-pointer" onClick={() => scrollToSection("hero")}>
          <img src={LOGO} alt="Brookpepper Logo" className="h-12 md:h-14 w-auto rounded-lg" />
        </div>
        
        <div className="hidden lg:flex items-center gap-6">
          {navItems.map((item) => (
            <button
              key={item.id}
              data-testid={`nav-${item.id}`}
              onClick={() => scrollToSection(item.id)}
              className={`font-sans uppercase tracking-widest text-xs font-semibold transition-colors duration-300 ${
                scrolled ? "text-olive hover:text-rust" : "text-cream hover:text-sage"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>

        <a 
          href="tel:+918179070606" 
          data-testid="nav-call-btn"
          className={`hidden md:block btn-primary text-sm ${scrolled ? "" : "bg-cream/20 backdrop-blur-sm border border-cream/30 text-cream hover:bg-cream hover:text-olive"}`}
        >
          Call Us
        </a>

        {/* Mobile menu button */}
        <button 
          className="lg:hidden p-2"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          data-testid="mobile-menu-btn"
        >
          <div className={`w-6 h-0.5 ${scrolled ? 'bg-olive' : 'bg-cream'} transition-all ${mobileMenuOpen ? 'rotate-45 translate-y-1.5' : ''}`} />
          <div className={`w-6 h-0.5 ${scrolled ? 'bg-olive' : 'bg-cream'} my-1.5 transition-all ${mobileMenuOpen ? 'opacity-0' : ''}`} />
          <div className={`w-6 h-0.5 ${scrolled ? 'bg-olive' : 'bg-cream'} transition-all ${mobileMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`} />
        </button>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="lg:hidden bg-cream/95 backdrop-blur-md border-t border-olive/10 mt-2"
        >
          <div className="px-6 py-4 space-y-3">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="block w-full text-left font-sans uppercase tracking-widest text-sm text-olive hover:text-rust py-2"
              >
                {item.label}
              </button>
            ))}
            <a 
              href="tel:+918179070606" 
              className="block btn-primary text-center text-sm mt-4"
            >
              Call Us
            </a>
          </div>
        </motion.div>
      )}
    </nav>
  );
};

// Hero Section
const HeroSection = () => {
  return (
    <section id="hero" data-testid="hero-section" className="hero-section">
      <div 
        className="hero-bg"
        style={{ 
          backgroundImage: `url(${HERO_BG})`
        }}
      />
      <div className="hero-overlay" />
      
      <div className="relative z-10 text-center px-6 max-w-4xl">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="font-sans uppercase tracking-widest text-xs text-cream/80 mb-4"
        >
          A Farm Stay Experience
        </motion.p>
        
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.8 }}
          className="font-serif text-5xl sm:text-6xl lg:text-7xl text-cream tracking-tight mb-6"
        >
          Peace in the<br />Palakayam Valley
        </motion.h1>
        
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.7, duration: 0.8 }}
          className="font-sans text-lg text-cream/90 max-w-2xl mx-auto leading-relaxed"
        >
          Nestled at 1000 ft elevation, surrounded by 100+ trees, with a brook flowing through — 
          your escape to nature awaits.
        </motion.p>
        
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2, duration: 0.8 }}
          className="absolute bottom-12 left-1/2 -translate-x-1/2 scroll-indicator"
        >
          <ChevronDown className="w-8 h-8 text-cream/70" />
        </motion.div>
      </div>
    </section>
  );
};

// About Section
const AboutSection = () => {
  return (
    <AnimatedSection className="py-24 md:py-32 px-6 md:px-12" id="about">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center">
          <div>
            <span className="font-sans uppercase tracking-widest text-xs text-rust mb-4 block">
              Welcome to Brookpepper
            </span>
            <h2 className="font-serif text-4xl sm:text-5xl text-olive tracking-tight mb-6">
              One Acre of Pure Solitude
            </h2>
            <div className="accent-bar mb-8" />
            <p className="font-sans text-olive/80 leading-relaxed mb-6">
              Brookpepper is a serene homestay nestled within a one-acre farm in the picturesque 
              Palakayam area, on the scenic route to the majestic Siruvani Dam. At an elevation of 
              1000 feet, the property offers breathtaking views of the nearby valley.
            </p>
            <p className="font-sans text-olive/80 leading-relaxed">
              The estate is home to over 100 trees including rubber, areca nuts, mango, and nutmeg, 
              all intertwined with climbing pepper vines. A natural brook flows along the property 
              boundaries, adding to the tranquil atmosphere.
            </p>
          </div>
          
          <div className="img-zoom rounded-lg overflow-hidden">
            <img 
              src={ABOUT_IMG} 
              alt="Brookpepper Farm" 
              className="w-full h-[400px] md:h-[500px] object-cover"
            />
          </div>
        </div>
      </div>
    </AnimatedSection>
  );
};

// Estate Features Section
const EstateSection = () => {
  const features = [
    { icon: Trees, title: "100+ Trees", desc: "Rubber, Areca, Mango & Nutmeg" },
    { icon: Leaf, title: "Pepper Vines", desc: "Climbing along the estate" },
    { icon: Droplets, title: "Natural Brook", desc: "Flowing along the boundaries" },
    { icon: Mountain, title: "1000 ft Elevation", desc: "Valley views nearby" }
  ];

  return (
    <AnimatedSection className="py-24 md:py-32 px-6 md:px-12 bg-sage/30" id="estate">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="font-sans uppercase tracking-widest text-xs text-rust mb-4 block">
            The Estate
          </span>
          <h2 className="font-serif text-4xl sm:text-5xl text-olive tracking-tight">
            Nature's Abundance
          </h2>
        </div>
        
        <motion.div 
          className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {features.map((feature, index) => (
            <motion.div
              key={index}
              variants={fadeInUp}
              className="feature-card text-center card-hover"
              data-testid={`feature-card-${index}`}
            >
              <div className="amenity-icon mx-auto mb-4">
                <feature.icon className="w-6 h-6" />
              </div>
              <h3 className="font-serif text-xl text-olive mb-2">{feature.title}</h3>
              <p className="font-sans text-sm text-olive/70">{feature.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </AnimatedSection>
  );
};

// Stay Section
const StaySection = () => {
  const rooms = [
    { icon: Bed, title: "2 Bedrooms", desc: "Comfortable and cozy sleeping quarters" },
    { icon: Armchair, title: "Living Hall", desc: "Spacious common area to relax" },
    { icon: UtensilsCrossed, title: "Furnished Kitchen", desc: "Fully equipped for your meals" },
    { icon: Home, title: "Sit-out & Dining", desc: "Indoor and outdoor dining spaces" }
  ];

  return (
    <AnimatedSection className="py-24 md:py-32 px-6 md:px-12" id="stay">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center">
          <div className="order-2 md:order-1">
            <div className="grid grid-cols-2 gap-4">
              {rooms.map((room, index) => (
                <div 
                  key={index}
                  className="feature-card card-hover"
                  data-testid={`room-card-${index}`}
                >
                  <room.icon className="w-8 h-8 text-rust mb-3" />
                  <h3 className="font-serif text-lg text-olive mb-1">{room.title}</h3>
                  <p className="font-sans text-xs text-olive/70">{room.desc}</p>
                </div>
              ))}
            </div>
          </div>
          
          <div className="order-1 md:order-2">
            <span className="font-sans uppercase tracking-widest text-xs text-rust mb-4 block">
              Your Stay
            </span>
            <h2 className="font-serif text-4xl sm:text-5xl text-olive tracking-tight mb-6">
              Home Away<br />From Home
            </h2>
            <div className="accent-bar mb-8" />
            <p className="font-sans text-olive/80 leading-relaxed">
              The homestay features two comfortable bedrooms, a spacious living hall, a fully 
              furnished kitchen, and a dedicated dining area with a lovely sit-out space. 
              Everything you need for a comfortable stay amidst nature.
            </p>
          </div>
        </div>
      </div>
    </AnimatedSection>
  );
};

// Amenities Marquee
const AmenitiesMarquee = () => {
  const amenities = [
    { icon: Wifi, text: "High-Speed WiFi" },
    { icon: ChefHat, text: "House Help Available" },
    { icon: WashingMachine, text: "Laundry Facilities" },
    { icon: UtensilsCrossed, text: "Furnished Kitchen" },
    { icon: Home, text: "Work Area" },
    { icon: Mountain, text: "Valley Views" }
  ];

  return (
    <div className="py-12 bg-olive" data-testid="amenities-marquee">
      <Marquee speed={40} gradient={false}>
        {[...amenities, ...amenities].map((amenity, index) => (
          <div key={index} className="flex items-center gap-3 mx-12">
            <amenity.icon className="w-5 h-5 text-cream" />
            <span className="font-sans uppercase tracking-widest text-sm text-cream">
              {amenity.text}
            </span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};

// Gallery Section with Tabs
const GallerySection = () => {
  const [activeTab, setActiveTab] = useState("farm");

  const tabs = [
    { id: "farm", label: "The Farm", images: FARM_GALLERY },
    { id: "house", label: "The House", images: HOUSE_GALLERY },
    { id: "views", label: "Viewpoints", images: VIEWPOINT_GALLERY }
  ];

  const currentImages = tabs.find(t => t.id === activeTab)?.images || FARM_GALLERY;

  return (
    <AnimatedSection className="py-24 md:py-32 px-6 md:px-12" id="gallery">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="font-sans uppercase tracking-widest text-xs text-rust mb-4 block">
            Gallery
          </span>
          <h2 className="font-serif text-4xl sm:text-5xl text-olive tracking-tight mb-8">
            Glimpses of Paradise
          </h2>
          
          {/* Gallery Tabs */}
          <div className="flex justify-center gap-2 flex-wrap" data-testid="gallery-tabs">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                data-testid={`gallery-tab-${tab.id}`}
                className={`px-6 py-3 rounded-full font-sans text-sm uppercase tracking-wider transition-all duration-300 ${
                  activeTab === tab.id 
                    ? "bg-olive text-cream" 
                    : "bg-sage/50 text-olive hover:bg-sage"
                }`}
              >
                <Camera className="w-4 h-4 inline-block mr-2" />
                {tab.label}
              </button>
            ))}
          </div>
        </div>
        
        <motion.div 
          key={activeTab}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="bento-grid" 
          data-testid="gallery-grid"
        >
          {currentImages.map((img, index) => (
            <div 
              key={index} 
              className="bento-item img-zoom rounded-lg overflow-hidden"
              data-testid={`gallery-image-${index}`}
            >
              <img 
                src={img} 
                alt={`${activeTab} Gallery ${index + 1}`}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </motion.div>
      </div>
    </AnimatedSection>
  );
};

// Nearby Attractions Section
const AttractionsSection = () => {
  return (
    <AnimatedSection className="py-24 md:py-32 px-6 md:px-12 bg-sage/30" id="attractions">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="font-sans uppercase tracking-widest text-xs text-rust mb-4 block">
            Explore the Region
          </span>
          <h2 className="font-serif text-4xl sm:text-5xl text-olive tracking-tight mb-4">
            Nearby Attractions
          </h2>
          <p className="font-sans text-olive/70 max-w-2xl mx-auto">
            Discover the natural wonders and hidden gems around Brookpepper. From pristine waterfalls to scenic dams.
          </p>
        </div>
        
        <motion.div 
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-6"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {NEARBY_ATTRACTIONS.map((attraction, index) => (
            <motion.div
              key={index}
              variants={fadeInUp}
              className="attraction-card group"
              data-testid={`attraction-card-${index}`}
            >
              <div className="relative h-48 overflow-hidden rounded-t-lg">
                <img 
                  src={attraction.image} 
                  alt={attraction.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 bg-cream/90 backdrop-blur-sm px-3 py-1 rounded-full flex items-center gap-1">
                  <Navigation className="w-3 h-3 text-rust" />
                  <span className="font-sans text-xs text-olive font-medium">{attraction.distance}</span>
                </div>
              </div>
              <div className="bg-white p-6 rounded-b-lg border border-t-0 border-olive/10">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-sage flex items-center justify-center">
                    <attraction.icon className="w-5 h-5 text-olive" />
                  </div>
                  <h3 className="font-serif text-xl text-olive">{attraction.name}</h3>
                </div>
                <p className="font-sans text-sm text-olive/70 leading-relaxed">
                  {attraction.description}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </AnimatedSection>
  );
};

// Testimonials Section
const TestimonialsSection = () => {
  return (
    <AnimatedSection className="py-24 md:py-32 px-6 md:px-12" id="testimonials">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="font-sans uppercase tracking-widest text-xs text-rust mb-4 block">
            Guest Reviews
          </span>
          <h2 className="font-serif text-4xl sm:text-5xl text-olive tracking-tight mb-4">
            What Our Guests Say
          </h2>
          <p className="font-sans text-olive/70 max-w-2xl mx-auto">
            Hear from travelers who've experienced the magic of Brookpepper
          </p>
        </div>
        
        <motion.div 
          className="grid md:grid-cols-2 gap-6"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {TESTIMONIALS.map((testimonial, index) => (
            <motion.div
              key={index}
              variants={fadeInUp}
              className="testimonial-card"
              data-testid={`testimonial-card-${index}`}
            >
              <Quote className="w-10 h-10 text-sage mb-4" />
              <p className="font-sans text-olive/80 leading-relaxed mb-6 italic">
                "{testimonial.text}"
              </p>
              <div className="flex items-center justify-between">
                <div>
                  <h4 className="font-serif text-lg text-olive">{testimonial.name}</h4>
                  <p className="font-sans text-sm text-olive/60">{testimonial.location}</p>
                </div>
                <div className="text-right">
                  <div className="flex gap-1 mb-1 justify-end">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-4 h-4 fill-rust text-rust" />
                    ))}
                  </div>
                  <p className="font-sans text-xs text-olive/50">{testimonial.date}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </AnimatedSection>
  );
};

// Location Section
const LocationSection = () => {
  return (
    <AnimatedSection className="py-24 md:py-32 px-6 md:px-12 bg-sage/30" id="location">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center">
          <div>
            <span className="font-sans uppercase tracking-widest text-xs text-rust mb-4 block">
              Find Us
            </span>
            <h2 className="font-serif text-4xl sm:text-5xl text-olive tracking-tight mb-6">
              Gateway to<br />Siruvani
            </h2>
            <div className="accent-bar mb-8" />
            <p className="font-sans text-olive/80 leading-relaxed mb-6">
              Located in the serene Palakayam area on the scenic route to Siruvani Dam, 
              Brookpepper is your perfect getaway from the hustle of city life.
            </p>
            
            <div className="flex items-start gap-4 mb-6">
              <MapPin className="w-6 h-6 text-rust flex-shrink-0 mt-1" />
              <div>
                <h4 className="font-serif text-lg text-olive mb-1">Address</h4>
                <p className="font-sans text-sm text-olive/70">
                  Palakayam, Near Siruvani Dam<br />
                  Kerala, India
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 mb-8">
              <Clock className="w-6 h-6 text-rust flex-shrink-0 mt-1" />
              <div>
                <h4 className="font-serif text-lg text-olive mb-1">Distances</h4>
                <p className="font-sans text-sm text-olive/70">
                  Palakkad Town: 30 km<br />
                  Coimbatore: 55 km<br />
                  Cochin Airport: 150 km
                </p>
              </div>
            </div>
            
            <a 
              href="https://www.google.com/maps?q=10.9748420,76.5669300"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline inline-block"
              data-testid="directions-btn"
            >
              Get Directions
            </a>
          </div>
          
          <div className="map-container h-[400px]" data-testid="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3918.8!2d76.5669300!3d10.9748420!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTDCsDU4JzI5LjQiTiA3NsKwMzQnMDEuMCJF!5e0!3m2!1sen!2sin!4v1"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Brookpepper Location"
            />
          </div>
        </div>
      </div>
    </AnimatedSection>
  );
};

// House Rules Section
const HouseRulesSection = () => {
  return (
    <AnimatedSection className="py-24 md:py-32 px-6 md:px-12" id="rules">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="font-sans uppercase tracking-widest text-xs text-rust mb-4 block">
            Important Information
          </span>
          <h2 className="font-serif text-4xl sm:text-5xl text-olive tracking-tight mb-4">
            House Rules
          </h2>
          <p className="font-sans text-olive/70 max-w-2xl mx-auto">
            Please read and acknowledge these rules before booking your stay
          </p>
        </div>
        
        <motion.div 
          className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {HOUSE_RULES.map((rule, index) => (
            <motion.div
              key={index}
              variants={fadeInUp}
              className="rules-card"
              data-testid={`rule-card-${index}`}
            >
              <div className="w-12 h-12 rounded-full bg-rust/10 flex items-center justify-center mb-4">
                <rule.icon className="w-6 h-6 text-rust" />
              </div>
              <h3 className="font-serif text-lg text-olive mb-2">{rule.title}</h3>
              <p className="font-sans text-sm text-olive/70 leading-relaxed">{rule.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </AnimatedSection>
  );
};

// How to Reach Section
const HowToReachSection = () => {
  return (
    <AnimatedSection className="py-24 md:py-32 px-6 md:px-12 bg-sage/30" id="reach">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="font-sans uppercase tracking-widest text-xs text-rust mb-4 block">
            Getting Here
          </span>
          <h2 className="font-serif text-4xl sm:text-5xl text-olive tracking-tight mb-4">
            How to Reach Us
          </h2>
          <p className="font-sans text-olive/70 max-w-2xl mx-auto">
            Directions from major cities to Brookpepper
          </p>
        </div>
        
        <motion.div 
          className="grid md:grid-cols-3 gap-6"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {HOW_TO_REACH.map((route, index) => (
            <motion.div
              key={index}
              variants={fadeInUp}
              className="reach-card"
              data-testid={`reach-card-${index}`}
            >
              <div className="flex items-center justify-between mb-4">
                <div className="w-12 h-12 rounded-full bg-olive flex items-center justify-center">
                  <route.icon className="w-6 h-6 text-cream" />
                </div>
                <div className="text-right">
                  <span className="font-serif text-2xl text-olive">{route.distance}</span>
                  <span className="font-sans text-xs text-olive/60 block">{route.duration}</span>
                </div>
              </div>
              <h3 className="font-serif text-xl text-olive mb-3">{route.city}</h3>
              <p className="font-sans text-sm text-olive/70 leading-relaxed">{route.directions}</p>
            </motion.div>
          ))}
        </motion.div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-3 bg-white/50 backdrop-blur-sm px-6 py-4 rounded-lg border border-olive/10">
            <Train className="w-5 h-5 text-olive" />
            <span className="font-sans text-sm text-olive">
              <strong>By Train:</strong> Nearest station is Palakkad Junction (30 km). Taxis available.
            </span>
          </div>
          <div className="inline-flex items-center gap-3 bg-white/50 backdrop-blur-sm px-6 py-4 rounded-lg border border-olive/10 ml-4 mt-4 md:mt-0">
            <Plane className="w-5 h-5 text-olive" />
            <span className="font-sans text-sm text-olive">
              <strong>By Air:</strong> Coimbatore Airport (55 km) or Cochin Airport (150 km)
            </span>
          </div>
        </div>
      </div>
    </AnimatedSection>
  );
};

// Contact/Footer Section
const ContactSection = () => {
  return (
    <footer id="contact" data-testid="contact-section" className="py-24 md:py-32 px-6 md:px-12 bg-olive text-cream">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center">
          <div>
            <img 
              src={LOGO} 
              alt="Brookpepper" 
              className="h-20 md:h-24 w-auto mb-8 rounded-lg"
            />
            <h2 className="font-serif text-4xl sm:text-5xl tracking-tight mb-6">
              Ready to<br />Escape?
            </h2>
            <p className="font-sans text-cream/80 leading-relaxed max-w-md">
              Get in touch with us to book your stay at Brookpepper. We look forward to 
              hosting you in our little slice of paradise.
            </p>
          </div>
          
          <div className="space-y-8">
            <a 
              href="mailto:hello@brookpepper.com"
              className="flex items-center gap-4 group"
              data-testid="contact-email"
            >
              <div className="w-14 h-14 rounded-full bg-cream/10 flex items-center justify-center group-hover:bg-cream/20 transition-colors">
                <Mail className="w-6 h-6" />
              </div>
              <div>
                <span className="font-sans uppercase tracking-widest text-xs text-cream/60 block mb-1">
                  Email Us
                </span>
                <span className="font-serif text-xl">hello@brookpepper.com</span>
              </div>
            </a>
            
            <a 
              href="tel:+918179070606"
              className="flex items-center gap-4 group"
              data-testid="contact-phone"
            >
              <div className="w-14 h-14 rounded-full bg-cream/10 flex items-center justify-center group-hover:bg-cream/20 transition-colors">
                <Phone className="w-6 h-6" />
              </div>
              <div>
                <span className="font-sans uppercase tracking-widest text-xs text-cream/60 block mb-1">
                  Call Us
                </span>
                <span className="font-serif text-xl">+91 81790 70606</span>
              </div>
            </a>
            
            <a 
              href="https://instagram.com/brookpepper"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-4 group"
              data-testid="contact-instagram"
            >
              <div className="w-14 h-14 rounded-full bg-cream/10 flex items-center justify-center group-hover:bg-cream/20 transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <span className="font-sans uppercase tracking-widest text-xs text-cream/60 block mb-1">
                  Follow Us
                </span>
                <span className="font-serif text-xl">@brookpepper</span>
              </div>
            </a>
            
            <a 
              href="https://www.google.com/maps?q=10.9748420,76.5669300"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-4 group"
              data-testid="contact-location"
            >
              <div className="w-14 h-14 rounded-full bg-cream/10 flex items-center justify-center group-hover:bg-cream/20 transition-colors">
                <MapPin className="w-6 h-6" />
              </div>
              <div>
                <span className="font-sans uppercase tracking-widest text-xs text-cream/60 block mb-1">
                  Location
                </span>
                <span className="font-serif text-xl">Palakayam, Kerala</span>
              </div>
            </a>
          </div>
        </div>
        
        <div className="divider my-16 bg-cream/10" />
        
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-sans text-sm text-cream/60">
            © {new Date().getFullYear()} Brookpepper. All rights reserved.
          </p>
          <p className="font-sans text-sm text-cream/60">
            A Farm Stay in the Heart of Nature
          </p>
        </div>
      </div>
    </footer>
  );
};

// Main App Component
function App() {
  return (
    <div className="App" data-testid="app-container">
      <div className="grain-overlay" />
      <NavigationBar />
      <HeroSection />
      <AboutSection />
      <EstateSection />
      <StaySection />
      <AmenitiesMarquee />
      <GallerySection />
      <AttractionsSection />
      <TestimonialsSection />
      <HouseRulesSection />
      <HowToReachSection />
      <LocationSection />
      <ContactSection />
    </div>
  );
}

export default App;
